exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-prepared-product-form input[data-v-cc70f7c4] {\n  text-align: right;\n  width: 60px;\n}\n.add-prepared-product-form input[data-v-cc70f7c4]::-moz-placeholder {\n  text-align: left;\n}\n.add-prepared-product-form input[data-v-cc70f7c4]::placeholder {\n  text-align: left;\n}", ""]);

// exports
